<template>
    <section>
        <header class="justify-between align-items-end mb-3">
            <b-form-group
                :label="$t('Service')"
                class="flex-grow-1 mb-0"
                label-for="wall_service"
            >
                <service-select
                    id="wall_service"
                    v-model="service"
                    :project-id="projectId"
                    required
                />
            </b-form-group>

            <b-button
                :disabled="!service || creating"
                :title="$t('Add service')"
                class="ml-3"
                @click="newService"
            >
                <b-spinner v-if="creating" small />
                <fa v-else :title="$t('Add service')" icon="plus" />
            </b-button>
        </header>

        <spinner v-if="pending" />

        <no-results-found v-if="!pending && !items.length" />

        <service-select-item
            v-for="(item, index) in items"
            :key="index"
            :value="items[index]"
            :api-url="apiUrl + '/' + item.id"
            :multipliers="servicesMultipliers"
            class="mb-3"
            @deleted="removeService(index)"
        />
    </section>
</template>
<script>
    import ServiceSelectItem from '@/components/ServiceSelectItem'
    import ServiceSelect from '@/components/selects/ServiceSelect';
    import fetchData from "@/mixins/fetchData";
    import NoResultsFound from "@/components/NoResultsFound";
    import Spinner from "@/components/Spinner";
    import WALLS_FIELDS_LOOKUP from "@/constants/walls_fields_lookup";

    export default {
        name: 'WallServices',
        components: {Spinner, NoResultsFound, ServiceSelect, ServiceSelectItem},
        mixins: [fetchData],
        props: {
            projectId: {
                type: [Number, String],
                required: true
            },
            wallId: {
                type: [Number, String],
                required: true
            },
            wallType: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                creating: false,
                service: null,
            }
        },
        computed: {
            apiUrl() {
                return `/api/walls/${this.wallId}/services`;
            },
            servicesMultipliers() {
                return WALLS_FIELDS_LOOKUP[this.wallType].filter(item => item.append === 'm');
            },
        },
        methods: {
            async newService() {
                if (!this.service || this.creating) {
                    return;
                }

                this.creating = true;

                try {
                    await this.axios.put(this.apiUrl + '/' + this.service.id)

                    this.$root.$emit('saved::wall-service');
                    this.items.push(Object.assign({}, this.service));
                    this.service = null;

                } catch (e) {
                    if (!e.response) {
                        throw e;
                    }
                } finally {
                    this.creating = false;
                }
            },

            removeService(index) {
                this.items.splice(index, 1)
            }
        }
    }
</script>
